
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRouteExportIec as ObiRouteExportIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-route-export-iec.js';
 
 
 

 
 export const ObiRouteExportIec = createComponent({
   react: React,
   tagName: 'obi-route-export-iec',
   elementClass: ObiRouteExportIecElement,
   events: {
     
   }
  });
 
 